/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sidebar_LayoutInputs */

const vi_nav_sidebar_layout = /** @type {(inputs: Nav_Sidebar_LayoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp menu`)
};

/**

* @param {Nav_Sidebar_LayoutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_sidebar_layout = /** @type {((inputs?: Nav_Sidebar_LayoutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sidebar_LayoutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_sidebar_layout(inputs)
});